import type { FilterQuery, PopulateOptions } from 'mongoose';

export class IStatus {
  label: string;
  color: string;
}

export class IRole {
  label: string;
  isHidden?: boolean;
}

export class IAddress {
  company?: string;
  address1?: string;
  address2?: string;
  city?: string;
  provinceCode?: string;
  /**@deprecated use provinceCode instead*/
  province?: string;
  countryCode?: 'CA' | 'US';
  postalCode?: string;
  /**@deprecated use countryCode instead*/
  country?: string;
}

export class IPharmacyAddress {
  name: string;
  phoneNumber: string;
  faxNumber: string;
  address1: string;
  address2: string;
  city: string;
  provinceCode: string;
  countryCode: 'CA' | 'US';
  postalCode: string;
}

export class PageBatch {
  page?: number;
  size?: number;
  orderBy?: string;
  orderDir?: 'ascend' | 'descend';
  segment?: string;
}

export class PageBatchResponse<T> {
  results: T[];
  info: {
    page: number;
    size: number;
    total: number;
  };
}

export class IStatusHistory<T> {
  prevStatus: T;
  newStatus: T;
  updatedAt: Date;
  userId: string;
}

export type IPopulate = PopulateOptions | PopulateOptions[];
export class IBaseListResponse<T> {
  data: T[];
  totalCount: number;
  hasMore: boolean;
  nextId?: string;
  error?: string;
}

export class IBaseListRequest<T> {
  query?: FilterQuery<T>;
  projection?: any;
  populate?: IPopulate;
  minId?: string;
  maxId?: string;
  limit?: number;
  includeCount?: boolean;
  sortOrder?: 'asc' | 'desc';
  sortField?: keyof T;
}
